<!-- 
    - This page takes your registered email and sends a otp to same email to create a new password
    - gotToLogin() is called if you dont want to recover password
    - sendEmail() is called to send the otp
    - resetPassword() is called once we have entered the otp and new password
    - Commented by Sarthak on Feb 12, 2024
 -->
<!--************************************Email*******************************************-->
<div *ngIf="emailBoxMain" class="container login_container">
    <form [formGroup]="userForm" (ngSubmit)="sendEmail()">
        <div class="row">
            <div class="col-md-4 mx-auto custom_mx">
                <div class="card-group login_outer">
                    <div class="card p-4">
                        <div class="card-body p_10">
                            <h2>Forgot Password</h2>
                            <p class="text-muted p_t_10">For resetting your password please enter your email.</p>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text no_radius"><i class="material-icons">email</i>
                                    </span>
                                </div>
                                <input type="text" class="form-control" placeholder="Email" autocomplete="username"
                                    formControlName="email" id="email">
                                <control-messages class="err-msg" [control]="userForm.controls.email">
                                </control-messages>
                            </div>
                            <div class="row actions_row" style="align-items: center;">
                                <div class="col-6">
                                    <button class="btn_my_login" mat-raised-button type="submit"
                                        [disabled]="!userForm.valid">Continue</button>
                                </div>
                                <div class="col-6 text-right">
                                    <button type="button" class="btn btn-link px-0 backTo_btn" style="color: #21b51d;"
                                        (click)="goToLogin()">Back to login</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>


<!-- 
    - Once OTP is sent successfully below code is executed to enter new password and otp recieved
    - Commented by Sarthak on Feb 12, 2024
 -->


<!--************************************Rest Password*******************************************-->
<div *ngIf="resetPasswordBoxMain" class="container login_container">
    <form [formGroup]="userForm" (ngSubmit)="resetPassword()">
        <div class="row">
            <div class="col-md-4 mx-auto custom_mx">
                <div class="card-group login_outer">
                    <div class="card p-4">
                        <div class="card-body">
                            <h1>Forgot Password</h1>
                            <p class="text-muted">Check your email <span class="etxt">{{emailID}}</span> for one time
                                password
                                (OTP). </p>


                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="material-icons">lock</i>
                                    </span>
                                </div>
                                <input type="password" class="form-control" placeholder="New password"
                                    formControlName="new_password" id="new_password">
                                <control-messages class="err-msg" [control]="userForm.controls.new_password">
                                </control-messages>
                            </div>

                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="material-icons">phonelink_lock</i>
                                    </span>
                                </div>
                                <input type="text" class="form-control" placeholder="OTP" formControlName="otp"
                                    id="otp">
                                <control-messages class="err-msg" [control]="userForm.controls.otp"></control-messages>
                            </div>


                            <div class="row">
                                <div class="col-6">
                                    <button class="btn_my_login" mat-raised-button type="submit"
                                        [disabled]="!userForm.valid">Reset</button>
                                </div>
                                <div class="col-6 text-right">
                                    <button type="button" class="btn btn-link px-0" style="color: #21b51d;"
                                        (click)="goToLogin()">Back to login</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>